// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"c0edcfa5","554":"a1eb35eb","602":"97511d20"}[chunkId] + ".chunk.js";
};